export function WinnerBanner({ session }) {

    if (!session?.votes) return null;

    const winnerId = Number(
        Object.keys(session.votes).reduce((a, b) =>
            session.votes[a] > session.votes[b] ? a : b
        )
    );

    const winner = session.suggestions.find(v => v.id === winnerId);

    if (!winner) return null;

    return (
        <div className="winner">
            Winner: {winner.title}
        </div>
    );
}
